import { createActions, createReducer } from 'reduxsauce'

import ItensContratadosService from '../../servicos/ItensContratadosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaItensContratadosInicio: [],
    buscaItensContratadosSucesso: ['itensContratados'],
    buscaItensContratadosErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaItensContratados = filtro => {
    return dispatch => {
        dispatch(Creators.buscaItensContratadosInicio())
        let serv = new ItensContratadosService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaItensContratadosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaItensContratadosErro(error)))
    }
}

const buscaItensContratadosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaItensContratadosErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaItensContratadosSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.itensContratados, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ITENS_CONTRATADOS_INICIO]: buscaItensContratadosInicio,
    [Types.BUSCA_ITENS_CONTRATADOS_ERRO]: buscaItensContratadosErro,
    [Types.BUSCA_ITENS_CONTRATADOS_SUCESSO]: buscaItensContratadosSucesso,
})
